import { enableXRay } from '../state/ui-store';
import { changeXrayVisibilityGroup } from './change-xray-visibility-group';

export const displayXrayView = () => {
  enableXRay();
  changeXrayVisibilityGroup();
};
